import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { findNavLeaf } from '../navigation'
import { Breadcrumbs, type Crumb } from './Breadcrumbs'

interface PageHeaderProps {
  title?: string
  description?: ReactNode
  actions?: ReactNode
  /** Sobrescreve a trilha derivada da navegação (DEC-006). */
  breadcrumbs?: Crumb[]
}

/** Cabeçalho padrão das páginas: trilha (Operacional › Agendamentos › Pedidos), título e ações. */
export function PageHeader({ title, description, actions, breadcrumbs }: PageHeaderProps) {
  const { pathname } = useLocation()
  const match = findNavLeaf(pathname)
  const crumbs: Crumb[] =
    breadcrumbs ??
    (match ? [...match.trail.map((label) => ({ label })), { label: match.leaf.label }] : [])
  const heading = title ?? match?.leaf.label ?? ''
  const subtitle = description ?? match?.leaf.description

  return (
    <div className="space-y-3">
      {crumbs.length > 0 ? <Breadcrumbs items={crumbs} /> : null}
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold tracking-tight">{heading}</h1>
          {subtitle ? <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </div>
  )
}
